import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ButtonPrimary from "../../components/button/ButtonPrimary";
import logoB from "../../media/images/logo-b.svg";
import axios from "axios";
import { authAPI, getConfig } from "../../apis";
import { toast } from "react-toastify";
import CheckIcon from "@mui/icons-material/Check";
import { Link } from "react-router-dom";
import VerifyConfirmation from "./VerifyConfirmation";

const EmailMessage = (props) => {
  const { type } = props;
  const navigate = useNavigate();
  const [confirmationPopup, setConfirmationPopup] = useState(false);

  async function resendSignupConfirmation() {
    try {
      const res = await axios.post(
        authAPI.resendConfirmation,
        {},
        { params: { email: localStorage.getItem("email") } }
      );

      if (res.data) {
        toast.success(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function resendForgotConfirmation() {
    try {
      const res = await axios.post(authAPI.forgotPassword, {
        email: localStorage.getItem("email"),
      });

      if (res.data) {
        toast.success(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  }
  return (
    <div className="email-message">
      <div className="logo">
        <img src={logoB} alt="logo" />
      </div>
      <p>
        A confirmation email is on its way. The email will be from
        <span className="bold underline"> info@sooth.fyi</span>
      </p>
      <div className="mb-2 mt-2">
        <p className="bold mb-1">Don't see it</p>
        <p className="instruction mb-1">
          <CheckIcon /> Check your junk folder
        </p>
        <p className="instruction mb-1">
          <CheckIcon /> Check your spam folder
        </p>
        <p>Then click the resend button below.</p>
      </div>
      {type === "signup" && (
        <div className="flex mt-2 mb-2">
          <ButtonPrimary
            text="Resend Confirmation Email"
            onClick={resendSignupConfirmation}
          />
        </div>
      )}
      {type === "resetpassword" && (
        <div className="flex mb-2 mt-2">
          <ButtonPrimary
            text="Go back"
            className="mr-5"
            onClick={() => navigate(-1)}
          />
          <ButtonPrimary
            text="Send e-mail again"
            onClick={resendForgotConfirmation}
          />
        </div>
      )}
      {type === "signup" && (
        <div className="mt-2">
          <p className="bold mb-1">Still don't see it?</p>
          <p className="mb-1">
            That's ok! We can fix it by clicking{" "}
            <span
              className="underline pointer"
              onClick={() => setConfirmationPopup(true)}
            >
              here.
            </span>
          </p>
        </div>
      )}
      {type === "signup" && (
        <div className="flex mt-3">
          <ButtonPrimary text="Sign In" onClick={() => navigate(-1)} />
        </div>
      )}

      {confirmationPopup && (
        <VerifyConfirmation
          confirmationPopup={confirmationPopup}
          setConfirmationPopup={setConfirmationPopup}
        />
      )}
    </div>
  );
};

export default EmailMessage;
